import * as React from 'react';
import { connect } from 'react-redux';
import {
    Button,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    FormGroup,
    Table,
    Row
} from 'react-bootstrap';
import RadioInputSwitch from '../../components/common/RadioInputSwitch';
import { ICalendarItem } from '../calendar/Types';
import StylingUserCalendarPrintEventsListRow from './StylingUserCalendarPrintEventsListRow';
import * as Actions from './actions/CalendarActions';
import { Moment } from 'moment';
import { Translate } from '../../shared/LanguageService';
import { CapitalizeFirstLetter } from '../../components/common/TextHelpers';
import Loader from 'react-loader';
import moment from 'moment';

interface IStylingUserCalendarPrintEventsPropsActions {
    getCalendarPrintEvents: (from: any, to: any) => any;
}

interface IProps {
    show: boolean;
    hide: () => void;
    calendarItems: ICalendarItem[];
    actions: IStylingUserCalendarPrintEventsPropsActions;
    eventsPerDay: Array<any>;
}

interface IState {
    fetchedItems: Array<any>;
    radioValue: String;
    selectedDateRange: Array<Moment.moment>;
    selectedDate: Date;
    isLoading: boolean;
}

class StylingUserCalendarPrintEvents extends React.Component<IProps, IState> {
    private blockedEventType: number = 4;

    constructor(props: any) {
        super(props);

        this.state = {
            fetchedItems: [],
            radioValue: 'day',
            selectedDateRange: [moment(new Date()).format('YYYYMMDD')],
            selectedDate: new Date(),
            isLoading: false
        };
    }

    componentDidMount() {
        this.setCalendarItemList(moment(this.state.selectedDate));
    }

    setPrintableCalendarItems(startDate: Date, endDate: Date) {
        this.props.actions.getCalendarPrintEvents(moment(startDate), moment(endDate)).then(() => {
            this.setState({
                fetchedItems: this.props.eventsPerDay,
                isLoading: false
            } as IState);
        });
    }

    radioInputSwitchChange(eventArgs: any) {
        this.setState(
            {
                radioValue: eventArgs.target.name
            } as IState,
            () => this.setCalendarItemList(moment(this.state.selectedDate))
        );
    }

    previousDate() {
        let selectedDate = moment(this.state.selectedDate).subtract(
            '1',
            this.state.radioValue.toString()
        );

        this.setState({
            selectedDate: new Date(selectedDate.format())
        } as IState);

        this.setCalendarItemList(selectedDate);
    }

    nextDate() {
        let selectedDate = moment(this.state.selectedDate).add(
            '1',
            this.state.radioValue.toString()
        );

        this.setState({
            selectedDate: new Date(selectedDate.format())
        } as IState);

        this.setCalendarItemList(selectedDate);
    }

    setCalendarItemList(selectedDate: Moment.moment) {
        let startDate: Date = new Date();
        let endDate: Date = new Date();

        switch (this.state.radioValue) {
            case 'day':
                startDate = new Date(selectedDate.format());
                endDate = new Date(selectedDate.format());
                break;
            case 'week':
                startDate = new Date(selectedDate.day(1).format());
                endDate = new Date(selectedDate.day(7).format());
                break;
            case 'month':
                startDate = new Date(selectedDate.startOf('month').format());
                endDate = new Date(selectedDate.endOf('month').format());
                break;
            default:
                break;
        }

        this.setDateRange(moment(startDate), moment(endDate));
        this.setPrintableCalendarItems(startDate, endDate);
    }

    setDateRange(startDate: Moment.moment, endDate: Moment.moment) {
        let dates = [startDate.clone().format('YYYYMMDD')];
        if (startDate.format('YYYYMMDD') !== endDate.format('YYYYMMDD')) {
            let selectedDate = moment(startDate.clone().add(1, 'day'));
            while (selectedDate.dayOfYear() !== endDate.dayOfYear()) {
                dates.push(selectedDate.clone().format('YYYYMMDD'));
                selectedDate = selectedDate.add(1, 'day');
            }
            dates.push(moment(endDate).format('YYYYMMDD'));
        }

        this.setState({
            selectedDateRange: dates,
            fetchedItems: [],
            isLoading: true
        } as IState);
    }

    print = () => window.print();

    render() {
        return (
            <Modal show={this.props.show} onHide={this.props.hide}>
                <ModalHeader closeButton>
                    {Translate(
                        'photographercalendar/printevents/modal/header/choosedatesforprintouts'
                    )}
                </ModalHeader>
                <ModalBody>
                    <FormGroup className="radio-switch center hidden-print">
                        <RadioInputSwitch
                            name="day"
                            id="day"
                            checked={this.state.radioValue === 'day' ? true : false}
                            onChange={(e) => {
                                this.radioInputSwitchChange(e);
                            }}
                            label={Translate(
                                'photographercalendar/printevents/modal/body/radiobuttons/label/day'
                            )}
                        />
                        <RadioInputSwitch
                            name="week"
                            id="week"
                            checked={this.state.radioValue === 'week' ? true : false}
                            onChange={(e) => {
                                this.radioInputSwitchChange(e);
                            }}
                            label={Translate(
                                'photographercalendar/printevents/modal/body/radiobuttons/label/week'
                            )}
                        />
                        <RadioInputSwitch
                            name="month"
                            id="month"
                            checked={this.state.radioValue === 'month' ? true : false}
                            onChange={(e) => {
                                this.radioInputSwitchChange(e);
                            }}
                            label={Translate(
                                'photographercalendar/printevents/modal/body/radiobuttons/label/month'
                            )}
                        />
                    </FormGroup>

                    <FormGroup className="center">
                        <div className="center calendar-print-date-selecter">
                            <div className="visible-print"></div>
                            <Button
                                className="hidden-print icon-only btn-xs"
                                onClick={() => this.previousDate()}
                            >
                                <i className="material-icons">keyboard_arrow_left</i>
                            </Button>
                            {this.state.radioValue === 'day' &&
                                CapitalizeFirstLetter(
                                    moment(this.state.selectedDate).format('dddd[,] DD MMMM')
                                )}
                            {this.state.radioValue === 'week' &&
                                CapitalizeFirstLetter(
                                    Translate(
                                        'photographercalendar/printevents/modal/body/radiobuttons/label/week'
                                    ) +
                                        ' ' +
                                        moment(this.state.selectedDate).format('W')
                                )}
                            {this.state.radioValue === 'month' &&
                                CapitalizeFirstLetter(
                                    moment(this.state.selectedDate).format('MMMM')
                                )}
                            <Button
                                className="hidden-print icon-only btn-xs"
                                onClick={() => this.nextDate()}
                            >
                                <i className="material-icons">keyboard_arrow_right</i>
                            </Button>
                            <div className="visible-print"></div>
                        </div>
                    </FormGroup>
                    <FormGroup className="center visible-print">
                        <div>
                            (
                            {this.state.selectedDateRange.length === 1
                                ? moment(this.state.selectedDate).format('YYYY-MM-DD')
                                : moment(this.state.selectedDateRange[0]).format('YYYY-MM-DD') +
                                  '  -  ' +
                                  moment(
                                      this.state.selectedDateRange[
                                          this.state.selectedDateRange.length - 1
                                      ]
                                  ).format('YYYY-MM-DD')}
                            )
                        </div>
                    </FormGroup>
                    <FormGroup className="center">
                        <Row className="photographer-calendar-table">
                            <Table responsive className="order-table">
                                {this.state.fetchedItems &&
                                    this.state.selectedDateRange.map((date) => {
                                        if (this.state.fetchedItems.hasOwnProperty(date)) {
                                            return this.state.fetchedItems[date].map(
                                                (item: any, index: number) => {
                                                    return (
                                                        <StylingUserCalendarPrintEventsListRow
                                                            key={item.id}
                                                            index={index}
                                                            item={item}
                                                        />
                                                    );
                                                }
                                            );
                                        }
                                    })}
                            </Table>
                        </Row>
                        <Loader className="loader" loaded={!this.state.isLoading} scale={2.0} />
                    </FormGroup>
                </ModalBody>
                <ModalFooter>
                    <Button onClick={() => this.props.hide()}>
                        {Translate('photographercalendar/printevents/modal/footer/close')}
                    </Button>
                    <Button
                        onClick={() => {
                            this.print();
                        }}
                    >
                        {Translate('photographercalendar/printevents/modal/footer/print')}
                    </Button>
                </ModalFooter>
            </Modal>
        );
    }
}

function mapStateToProps(state: any, ownProps: any) {
    return {
        eventsPerDay: state.calendar.eventsPerDay
    };
}

function mapDispatchToProps(dispatch: any) {
    return {
        actions: {
            getCalendarPrintEvents: (from: any, to: any) =>
                dispatch(Actions.getCalendarPrintEvents(from, to))
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(StylingUserCalendarPrintEvents);
